import React, { Fragment, useRef, useState } from "react";
import { Table, Spinner, Button } from "react-bootstrap";
import "./contentManagement.css";
import API from "../../services/axiosInstance";
import Pagination from "../common_modules/pagination.js";
import { Link, useNavigate } from "react-router-dom";
import FilterBar from "../common_modules/filter";
import { AUTH_CODE } from "../security/authCodes.js";
import Permission from "../security/permission.js";
import { useAuth } from "../security/authContext";
import { FormLoader, useFormLoader } from "../common_modules/loader.js";
import { LuPenLine, LuPlus, LuTrash2, LuAudioLines, LuClipboardCopy, LuCopy } from "react-icons/lu";
import TranscodingInfo from "./transcodeInfo.js";
import { SearchIcon } from "../common_modules/commonIcons.js";

const ListingContentMgmt = () => {
    const [list, setList] = useState([]);
    const [paginationData, setpaginationData] = useState({});
    const [searchConfig, setSearchConfig] = useState();

    // global data
    const tableFields = [
        { label: "Id", value: "id", enableSorting: true, enableIcon: true },
        { label: "Name", value: "name", enableSorting: true, enableIcon: true },
        { label: "Guid", value: "guid", enableSorting: true, enableIcon: true },
        { label: "Video Path", value: "originalName", enableSorting: false, enableIcon: true },
        { label: "Poster Image Path", value: "originalName", enableSorting: false, enableIcon: true },
        { label: "Status", value: "status", enableSorting: false, enableIcon: false }
    ];

    // hooks
    const navigate = useNavigate();
    const { hasPermission } = useAuth();
    const { isLoading, startLoading, stopLoading } = useFormLoader(); // custom hook

    const contentList = async (search, page, field = "", order = "") => {
        startLoading();
        try {
            const size = 20;
            const res = await API.get(`/meta/content/list?search=${search}&page=${page}&size=${size}&field=${field}&order=${order}`);

            const data = res?.data?.data?.content;
            if (res.status === 200 && data) {
                setList(data);
                // save pagination information
                let pagination = res.data.data;
                delete pagination.content; //  remove data
                setpaginationData(pagination);
            } else {
                setList([]);
                setpaginationData({});
            }
        } catch (e) { } finally {
            stopLoading();
        }
    }

    const nextPage = (nextPage) => {
        contentList("", nextPage, searchConfig?.orderField, searchConfig?.orderDir)
    }

    const updateContentMgmt = (id) => {
        navigate(`/content-management/${id}`)
    }

    const transcodeVideoByContentId = async (contentId) => {
        // startLoading();
        // let res = null;
        // try {
        //     res = await API.get(`meta/content/transcode/by/${contentId}`);
        //     if (res.status === 200) {
        //         // alert("Transcoding successfully..");
        //         contentList("", paginationData.number);
        //     }
        // } catch (e) { } finally {
        //     stopLoading();
        // }

        // rediract on transcoding info page 
        // transcodingInfo(res?.data?.data);
        transcodingInfo(contentId);
    }

    const deleteByContentId = async (contentId) => {
        startLoading();
        try {
            if (window.confirm("do you want to delete this file !!!")) {
                const res = await API.delete(`meta/content/delete/by/${contentId}`);
                if (res.status === 200) {
                    alert("Deleted successfully..");
                    if (paginationData.numberOfElements == 1) {
                        contentList("", paginationData.number - 1);
                    } else {
                        contentList("", paginationData.number);
                    }
                }
            }
        } catch (e) { } finally {
            stopLoading();
        }
    }

    const copyToClipboard = async (url) => {
        try {
            await navigator.clipboard.writeText(url);
            alert("URL copied!");
        } catch (err) {
            console.error("Copy failed", err);
        }
    };

    const onChangeSearch = (params) => {
        setSearchConfig(params)
        contentList(params.keyword, 0, params.orderField, params.orderDir); // API call
    }

    const transcodingInfo = (contentId) => {
        // navigate("/content-management/transcoding-info", {
        //     state: data
        // });

        window.open(
            `/content-management/transcoding-info?contentId=${contentId}`,
            "_blank"
        );
    }

    return (
        <FormLoader isLoading={isLoading} text={"Loading..."}>
            <div>
                <div className="breadCrumb gradient-bg">
                    <Link to={'/dashboard'}><span>Home</span></Link>
                    <span>Meta Admin</span>
                    <span>Content Management</span>
                </div>
                <h4 className="my-4">🧾 Content Management</h4>
                {/* <div className="active-table-wrapper"> */}
                {/* <div style={{
                        paddingBottom: "0.8rem",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}> */}
                <div className="filter row">
                    <Permission code={AUTH_CODE.contentManagement.create}>
                        <Link
                            to={"/content-management/add"}
                            className="btn btn-primary btn-md addBtn"
                            style={{ whiteSpace: "nowrap" }}>
                            Create Content  <LuPlus />
                        </Link>
                    </Permission>

                    <Permission code={AUTH_CODE.contentManagement.listing}>
                        <FilterBar fields={tableFields} onSearch={onChangeSearch} />
                    </Permission>
                </div>
                {/* </div> */}
                <Permission code={AUTH_CODE.contentManagement.listing}>
                    <div className="mt-0 table-wrapper mt-3">
                        <Table striped bordered responsive hover size="sm" className="custom-table align-middle">
                            <thead>
                                <tr>
                                    <th>☰</th>
                                    {
                                        tableFields?.map((item, i) => (
                                            <th key={i}>
                                                {item.label}
                                                {item.enableIcon ? <SearchIcon className="ms-1" size={10} fill="white" /> : ""}
                                            </th>
                                        ))
                                    }
                                    <th className="text-center">Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                {
                                    list.length > 0 &&
                                    list.map((item, index) => {
                                        return (
                                            <tr key={index} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 * index }} className="hover-glow">
                                                <td>{(paginationData.number * paginationData.size) + (index + 1)}</td>
                                                <td>{item.id}</td>
                                                <td>
                                                    {
                                                        hasPermission(AUTH_CODE.contentManagement.editUpdate) ?
                                                            <div title={item?.name} onClick={() => updateContentMgmt(item.id)}>
                                                                <Link style={{ textDecoration: "none" }}>
                                                                    {item?.name?.length > 20
                                                                        ? item?.name.substring(0, 20) + "..."
                                                                        : item?.name}
                                                                </Link>
                                                            </div>
                                                            : <div title={item?.name}>{item?.name?.length > 20
                                                                ? item?.name.substring(0, 20) + "..."
                                                                : item?.name}</div>
                                                    }

                                                </td>
                                                <td>
                                                    <div title={item?.guid}>
                                                        {/* {item?.guid?.length > 20
                                                            ? item?.guid.substring(0, 20) + "..."
                                                            : item?.guid} */}
                                                        {item?.guid}
                                                    </div>
                                                </td>
                                                <td> {/* video */}
                                                    <span title={item?.contentFiles[0]?.originalName}>
                                                        {item?.contentFiles[0]?.originalName?.length > 20
                                                            ? item?.contentFiles[0]?.originalName.substring(0, 20) + "..."
                                                            : item?.contentFiles[0]?.originalName}
                                                    </span>
                                                    <center className="activePubAllBtns">
                                                        <button className="" onClick={() => copyToClipboard(item?.contentFiles[0]?.cdnFileName)}>Copy <LuCopy /></button>
                                                        {item?.contentFiles[0]?.transcodeStatus === 1 &&
                                                            <button className="" onClick={() => copyToClipboard(item?.contentFiles[0]?.cdnTranscodeFile)}>Copy Transcoded <LuClipboardCopy /> </button>
                                                        }
                                                    </center>
                                                </td>
                                                <td>{/* image */}
                                                    <span title={item?.contentFiles[1]?.originalName}>
                                                        {item?.contentFiles[1]?.originalName?.length > 20
                                                            ? item?.contentFiles[1]?.originalName.substring(0, 20) + "..."
                                                            : item?.contentFiles[1]?.originalName}
                                                    </span>
                                                    <center className="activePubAllBtns">
                                                        {/* {item?.contentFiles[0]?.uploadType == 1 ? */}
                                                        <img width={50} src={item?.contentFiles[1]?.cdnFileName} alt={index} className="posterImg" />
                                                        {/* : ""} */}
                                                        <button className="" onClick={() => copyToClipboard(item?.contentFiles[1]?.cdnFileName)}>Copy <LuCopy /></button>
                                                    </center>
                                                </td>
                                                <td style={{ textAlign: "center" }}>
                                                    <span className={`badge ${item?.status === 1 ? "active" : "inactive"}`}>
                                                        {item?.status === 1 ? "Active" : "Inactive"}
                                                    </span>
                                                </td>
                                                <td className="activePubAllBtns">
                                                    <Permission code={AUTH_CODE.contentManagement.editUpdate}>
                                                        <button onClick={() => updateContentMgmt(item.id)} >Edit <LuPenLine /></button>
                                                    </Permission>
                                                    <Permission code={AUTH_CODE.contentManagement.delete}>
                                                        <button onClick={() => deleteByContentId(item.id)} >Delete <LuTrash2 /> </button>
                                                    </Permission>
                                                    {item.contentFiles.map((k, i) => {
                                                        return (
                                                            <Fragment key={i}>
                                                                {
                                                                    (k?.contentType.startsWith("video/") && k?.uploadType === 0) &&
                                                                    // k?.transcodeStatus == 0 ?
                                                                    <button onClick={(e) => transcodeVideoByContentId(item.id)} >Trancode {k?.transcodeStatus == 0 ? "Video" : "Info"} <LuAudioLines /> </button>
                                                                    // : <button className="coustom-button" onClick={(e) => transcodingInfo(item.id)} >Trancode Info</button>

                                                                }
                                                            </Fragment>
                                                        );
                                                    })}
                                                </td>
                                            </tr>
                                        );
                                    })
                                }
                            </tbody>
                        </Table>
                        {
                            list.length <= 0 && <center>No Data Found !!!</center>
                        }
                    </div>
                    {/* pagination */}
                    <Pagination
                        jumpPage={true}
                        count={true}
                        component={ListingContentMgmt.name}
                        size={"sm"}
                        paginationData={paginationData}
                        nextPage={nextPage} />
                </Permission>
                {/* </div> */}
            </div>
        </FormLoader>
    );
};

export default ListingContentMgmt;
